t = require('views/internal/teacup-with-helpers')('org_export_item')

module.exports = ->
  t.div { class: 'org-export-list-item u-clearfix' + t.mustacheBlock('generating', (-> ' org-export-list-item-generating')) }, ->
    t.mustacheBlock 'generating', ->
      t.p '.org-export-list-item-title', ->
        t.mustacheBlock 'status', ->
          t.text t.mustacheVar('stage')
          t.mustacheBlock 'total', ->
            t.format 'progress-of-total', { progress: t.mustacheVar('progress'), total: t.mustacheVar('total') }
        t.mustacheBlockInverted 'status', ->
          t.format 'creating-new-export-ellipsis'

    t.mustacheBlockInverted 'generating', ->
      t.p '.org-export-list-item-title', ->
        t.mustacheBlock 'attachments', ->
          t.format 'time-size-includes-attachments', { time: t.mustacheVar('time'), size: t.mustacheVar('size') }
        t.mustacheBlockInverted 'attachments', ->
          t.format 'time-size', { time: t.mustacheVar('time'), size: t.mustacheVar('size') }

      t.a '.button-link.org-export-list-item-button.js-download-export', { href: t.mustacheVar('exportUrl'), target: '_blank' }, ->
        t.format 'download'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_export_item.coffee